import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { db } from './config/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { AccountType, CategoryType } from './types';
import categoryService from './services/category.service';
import productService from './services/product.service';
import './App.css';
import { currencyFormatter } from './utils';
import { Helmet } from 'react-helmet-async';
import { AppBar, Backdrop, Box, Card, CardContent, CircularProgress, Grid, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Toolbar, Typography, FormControl, OutlinedInput, InputAdornment } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SearchIcon from '@mui/icons-material/Search';

function App() {

  const menuId = '1';

  const location = useLocation();


  const [accountId, setAccountId] = useState<string | null | undefined>()

  const [account, setAccount] = useState<AccountType>()
  const [data, setData] = useState<CategoryType[]>([]);
  const [textSearch, setTextSearch] = useState<string>()

  const [loading, setLoading] = useState(false)
  const [filteredItems, setFilteredItems] = useState<CategoryType[] | undefined>([]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const _accountId = searchParams.get('aid') !== null ? searchParams.get('aid') : window.location.host.split('.')[0];
    setAccountId(_accountId);
  }, [location]);

  useEffect(() => {
    async function fetchData() {
      setLoading(true)
      setAccount(undefined)
      setFilteredItems(undefined);
      if (accountId) {
        const accountSnap = await getDoc(doc(db, 'accounts', accountId))
        if (accountSnap.exists()) {
          const accountData = accountSnap.data();
          console.log(accountData);
          setAccount(accountData as AccountType)
          const _categories = await categoryService.getAll(accountId, menuId);
          let _products = await productService.getAll(accountId, menuId);
          _products = _products as any[];
          const _data = _categories.map((category) => ({
            ...category,
            products: _products.length > 0 ? _products.filter((it) => it.categoryId === category.id) : [],
          }));
          setData(_data);
        }
      }
      setLoading(false)
    }
    if (accountId && accountId !== null) {
      fetchData();
    }
  }, [accountId])

  useEffect(() => {
    if (textSearch && textSearch.length > 2) {
      let _items: any[] = [];
      data.map((category) => {
        let _category = { ...category };
        _category.products = category.products.filter(c => c.name.toLocaleLowerCase().includes(textSearch.toLocaleLowerCase()))
        _items.push(_category);
        return category;
      });
      setFilteredItems(_items);
      _items = _items.filter(c => c.products.length > 0);
      setFilteredItems(_items);
    } else {
      setFilteredItems(undefined);
    }
  }, [data, textSearch])


  return (
    <>
      <Helmet>
        <title> {account ? `${account.name} | BMENU` : 'BMENU'}</title>
      </Helmet>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {account && data.length > 0 && (
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="static" sx={account ? { background: account.style.primaryColor } : undefined}>
            <Toolbar>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {account ? account.name : 'BMENU'}
              </Typography>
            </Toolbar>
          </AppBar>
          {/* <br />
          <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', overflowX: 'auto' }}>
            <Typography sx={{ minWidth: 100 }}>Contact</Typography>
            <Typography sx={{ minWidth: 100 }}>Profile</Typography>
            <Typography sx={{ minWidth: 100 }}>Contact</Typography>
            <Typography sx={{ minWidth: 100 }}>Profile</Typography>
            <Typography sx={{ minWidth: 100 }}>Contact</Typography>
            <Typography sx={{ minWidth: 100 }}>Profile</Typography>
            <Typography sx={{ minWidth: 100 }}>Contact</Typography>
            <Typography sx={{ minWidth: 100 }}>Profile</Typography>
          </Box>
          <br /> */}
          <br />
          <Box sx={{ paddingLeft: 2, paddingRight: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}
              >
                <FormControl variant="standard" fullWidth>
                  <OutlinedInput
                    id="input-with-icon-adornment"
                    startAdornment={
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    }
                    placeholder='Pesquisar ...'
                    onChange={(e) => setTextSearch(e.target.value)}
                  />
                </FormControl>
              </Grid>
              {(!textSearch || textSearch.length <= 2) && data.filter(f => f.products.length > 0).map((row, index) => (
                <Grid item xs={12} key={index}>
                  <Card>
                    <CardContent>
                      <Stack flexDirection={'row'} alignContent={'center'} alignItems={'center'}>
                        <PlayArrowIcon sx={account ? { color: account.style.primaryColor } : undefined} />
                        <Typography variant="h5" component="div" color={account ? account.style.primaryColor : undefined}>
                          {row.name}
                        </Typography>

                      </Stack>
                      {row.description && (
                        <Typography variant='subtitle1' sx={account ? { color: account.style.primaryColor } : undefined}>{row.description}</Typography>
                      )}

                    </CardContent>
                    <TableContainer>
                      <Table>
                        <TableBody>
                          {row.products.map((product) => {
                            const { id, name, price } = product;
                            return (
                              <TableRow hover key={id} tabIndex={-1}>
                                <TableCell>
                                  <Typography variant="h6" noWrap>
                                    {name}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: '20%', textAlign: 'right' }}>
                                  <Typography variant="h6" noWrap >
                                    {price && currencyFormatter(price, undefined)}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </Grid>
              ))}
              {(textSearch && textSearch.length > 2 && filteredItems) && filteredItems.map((row, index) => (
                <Grid item xs={12} key={index}>
                  <Card>
                    <CardContent>
                      <Stack flexDirection={'row'} alignContent={'center'} alignItems={'center'}>
                        <PlayArrowIcon sx={account ? { color: account.style.primaryColor } : undefined} />
                        <Typography variant="h5" component="div" color={account ? account.style.primaryColor : undefined}>
                          {row.name}
                        </Typography>

                      </Stack>
                      {row.description && (
                        <Typography variant='subtitle1' sx={account ? { color: account.style.primaryColor } : undefined}>{row.description}</Typography>
                      )}

                    </CardContent>
                    <TableContainer>
                      <Table>
                        <TableBody>
                          {row.products.map((product) => {
                            const { id, name, price } = product;
                            return (
                              <TableRow hover key={id} tabIndex={-1}>
                                <TableCell>
                                  <Typography variant="h6" noWrap>
                                    {name}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: '20%', textAlign: 'right' }}>
                                  <Typography variant="h6" noWrap >
                                    {price && currencyFormatter(price, undefined)}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
          <br />
        </Box>
      )}

    </>
    // <>
    //   {account && (
    //     <>
    //       <Header $backgroundColor={account.style && account.style.primaryColor ? account.style.primaryColor : undefined} >
    //         <Title>{account && account.name}</Title>
    //       </Header>
    //       {/* {account && menu && (
    //         <>
    //         <SearchContainer>
    //           <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="bi bi-search search-icon"><path fillRule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"></path><path fillRule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"></path></svg>
    //           <SearchInput value={textSearch || ''} onChange={(e) => setTextSearch(e.target.value)} placeholder='Buscar' />
    //           {textSearch && textSearch.length > 2 && (
    //             <svg onClick={() => setTextSearch(undefined)} width="1em" height="1em" viewBox="0 0 16 16" fill={account.style && account.style.primaryColor ? account.style.primaryColor : 'currentColor'} xmlns="http://www.w3.org/2000/svg" className="bi bi-x-circle-fill clear-icon ng-star-inserted"><path fillRule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path></svg>
    //           )}
    //         </SearchContainer>

    //         <Wrapper>
    //             {(!textSearch || textSearch.length <= 2) && menu.categories.filter(f => f.products.length > 0).map((category, i) => (
    //               <div key={`category${i}`}>
    //                 <CategoryTitle $color={account.style && account.style.primaryColor ? account.style.primaryColor : undefined}>{category.name}</CategoryTitle>
    //                 {category.products.map((product, j) => (
    //                   <Item key={`item-${j}`}>
    //                     <ItemTitle>{product.name}</ItemTitle>
    //                     <ItemDescription>{product.description}</ItemDescription>
    //                     <ItemPrice $color={account.style && account.style.primaryColor ? account.style.primaryColor : undefined}>{product.price && currencyFormatter(product.price, undefined)}</ItemPrice>
    //                   </Item>
    //                 ))}
    //                 <br />
    //               </div>
    //             ))}
    //             {(textSearch && textSearch.length > 2 && filteredItems) && filteredItems.map((item, i) => (
    //               <Item key={`item-${i}`}>
    //                 <ItemTitle>{item.name}</ItemTitle>
    //                 <ItemDescription>{item.description}</ItemDescription>
    //                 <ItemPrice $color={account.style && account.style.primaryColor ? account.style.primaryColor : undefined}>{item.price && currencyFormatter(item.price, undefined)}</ItemPrice>
    //               </Item>
    //             ))}
    //           </Wrapper></>
    //       )} */}
    //     </>
    //   )}
    // </>
  );
}

export default App;
